<template>
<b-row class="ot-main-panel no-gutters OTSettings">
    <b-col>
        <otif-vertical-nav id="nav-general-settings" header="General Settings">
            <otif-vertical-navItem to="/settings/security">Security</otif-vertical-navItem>
        </otif-vertical-nav>
        <otif-vertical-nav id="nav-twitter-settings" header="Twitter Crawler Settings">
            <otif-vertical-navItem to="/settings/twitter">Application Keys</otif-vertical-navItem>
        </otif-vertical-nav>
        <otif-vertical-nav id="nav-ecm-settings" header="ECM & RDBMS Crawler Settings" collapsed>
            <otif-vertical-navItem to="/settings/oticrepository">ETL Service</otif-vertical-navItem>
            <otif-vertical-navItem to="/settings/ecmrepository">Crawling Service</otif-vertical-navItem>
            <otif-vertical-navItem to="/settings/ecmrepotypes">Connectors</otif-vertical-navItem>
            <otif-vertical-navItem to="/settings/oticconfigurations">Advanced Settings</otif-vertical-navItem>
            <otif-vertical-navItem to="/settings/ecmrepositories">ECM Repositories</otif-vertical-navItem>
            <otif-vertical-navItem to="/settings/rdbmsrepositories">RDBMS Repositories</otif-vertical-navItem>
        </otif-vertical-nav>
        <otif-vertical-nav id="nav-pipeline-settings" header="Pipeline" collapsed>
            <otif-vertical-navItem :to="{name: 'pipeline-ingestion-settings'}">Ingestion Settings</otif-vertical-navItem>
            <otif-vertical-navItem :to="{name: 'pipeline-persistence-settings'}">Persistence Settings</otif-vertical-navItem>
            <otif-vertical-navItem :to="{name: 'pipeline-html-processing'}">HTML Processing</otif-vertical-navItem>
            <otif-vertical-navItem :to="{name: 'pipeline-contentproc-settings'}">Content Processing</otif-vertical-navItem>
            <otif-vertical-navItem :to="{name: 'pipeline-advanced-settings'}">Advanced Settings</otif-vertical-navItem>
            <otif-vertical-navItem :to="{name: 'pipeline-activation-rules'}">Activation Rules</otif-vertical-navItem>
            <otif-vertical-navItem :to="{name: 'pipeline-tme-settings'}">Annotation Service Settings</otif-vertical-navItem>
        </otif-vertical-nav>
        <otif-vertical-nav id="nav-annotation-settings" header="Text Mining Engine">
            <otif-vertical-navItem :to="{name: 'annotation-profiles'}">Annotation Profiles</otif-vertical-navItem>
            <!--
            <otif-vertical-navItem :to="{name: 'pipeline-contentproc-settings'}">Connection Settings</otif-vertical-navItem>
            <otif-vertical-navItem :to="{name: 'pipeline-tme-advanced'}">Advanced Settings</otif-vertical-navItem>
            -->
        </otif-vertical-nav>
        <otif-vertical-nav id="nav-searchapi-settings" header="Search API">
            <otif-vertical-navItem :to="{name: 'search-api-monitoring'}">Settings</otif-vertical-navItem>
            <otif-vertical-navItem :to="{name: 'search-api-collections'}">Collections</otif-vertical-navItem>
            <otif-vertical-navItem :to="{name: 'search-api-repositories'}">Repositories</otif-vertical-navItem>
        </otif-vertical-nav>
    </b-col>
    <b-col cols="12" md="9">
        <router-view></router-view>
    </b-col>
</b-row>
</template>

<script>

export default {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (!vm.$session.isAdmin) {
                vm.$router.push('/');
            }
        });
    }
}
</script>
